//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { Like2BuyV2ModerationItemFilter } from '@apis/like2buy-v2/like2BuyV2ModerationModel';
import { DEFAULT_LIKE2BUY_V2_FILTER } from '@like2buy-v2/like2BuyV2UIUtils';

export const DEFAULT_TIKTOK_LIKE2BUY_FILTER = DEFAULT_LIKE2BUY_V2_FILTER;

export const DUPLICATE_MODAL_MEDIA_SIZE = '94px';

export const ASPECT_RATIO = 3 / 4;

export const tikTokLike2BuyFilters = [
  {
    value: Like2BuyV2ModerationItemFilter.AllMedia,
    label: 'All Media',
    contextText:
      'We will automatically publish media with tagged products and rights approved to your TikTok Like2Buy store.',
  },
  {
    value: Like2BuyV2ModerationItemFilter.ActionNeeded,
    label: 'Action Needed',
    contextText:
      'Tag products or request rights for this media to publish to your TikTok Like2Buy store.',
  },
  {
    value: Like2BuyV2ModerationItemFilter.Published,
    label: 'Published',
    contextText:
      'Published media currently appears on your TikTok Like2Buy store.',
  },
  {
    value: Like2BuyV2ModerationItemFilter.Archived,
    label: 'Archived',
    contextText:
      'Archived media does not appear in your TikTok Like2Buy store.',
  },
];
